export enum MultimediaContentType {
  image = 0,
  video = 1,
  code = 2,
}
